import React, { memo, forwardRef } from "react";
const SvgDoublebond = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M8 11a1 1 0 100 2h16a1 1 0 100-2H8zm0 8a1 1 0 100 2h16a1 1 0 100-2H8z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgDoublebond.displayName = "SvgDoublebond";
const MemoForwardRef = memo(SvgDoublebond);
export default MemoForwardRef;
